<div class="cbc-auto-exchange-dialog">
  <div class="cbc-auto-exchange-default">
    <span>Default Value: &nbsp;&nbsp;&nbsp; {{cbcAutomaticExchangeDefaultValue}}</span>
  </div>

  <div class="cbc-auto-exchange-overwrite">
    <mat-checkbox [(ngModel)]="autoExchangeOverwrite">Overwrite</mat-checkbox>
    <mat-radio-group class="overwrite-options" [(ngModel)]="overwrittenCellValue">
      <mat-radio-button class="overwrite-option-value" [disabled]="!autoExchangeOverwrite"  value="Yes">Yes</mat-radio-button>
      <mat-radio-button class="overwrite-option-value" [disabled]="!autoExchangeOverwrite"  value="No">No</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
